module.exports = __webpack_public_path__ + "img/riekkola_sisalta5.aa523c07.jpg";